module.exports = __webpack_public_path__ + "static/media/image.61c0be53.webp";